import { EnvironmentInjector, Injectable, Injector } from '@angular/core';
import { modalAnimation, modalController, ModalOptions } from '@inscomponents/core';
import { FrameworkDelegate } from './framework-delegate.service';
import { OverlayBaseController } from './overlay';

@Injectable({providedIn: 'root'})
export class ModalController extends OverlayBaseController<ModalOptions, HTMLInsModalElement> {
    public constructor(
        private frameworkDelegate: FrameworkDelegate,
        private environmentInjector: EnvironmentInjector,
        private injector: Injector,
    ) {
        super(modalController);
    }

    public override create(opts: ModalOptions): Promise<HTMLInsModalElement> {
        Object.assign(opts, {
            enterAnimation: modalAnimation.enterAnimation,
            leaveAnimation: modalAnimation.leaveAnimation,
        });
        return super.create({
            ...opts,
            delegate: this.frameworkDelegate.create(this.environmentInjector, this.injector),
        });
    }
}
